import React, { useState, useEffect, useRef } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import Popup from '../../components/Popup';

import ransomwareAlert from '../../assets/images/ransomware-alert.png';
import popupImage from '../../assets/images/padlock-3.png';
import tumbleweed from '../../assets/images/tumbleweed.gif';

function Module5() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();
  
  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

    const handleSuccess = () => {
    setCanContinue(true);
  };
  
  // Popup
  const [showPopup, setShowPopup] = useState(false);

  // - Time-based popup after page load
  //const showAfterSeconds = 3; // 3 seconds
  const showAfterSeconds = 0; // Straight away

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, showAfterSeconds * 1000);

    return () => clearTimeout(timer);
  }, []);

  // - Manual popup trigger using class
  useEffect(() => {
    const triggers = document.querySelectorAll('.popup-trigger');
    triggers.forEach(trigger =>
      trigger.addEventListener('click', () => setShowPopup(true))
    );

    return () => {
      triggers.forEach(trigger =>
        trigger.removeEventListener('click', () => setShowPopup(true))
      );
    };
  }, []);

  // Show/hide popup div content
  const [activeDiv, setactiveDiv] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0); // Used to force re-render

  const handleOpen = (divId) => {
    setactiveDiv(divId);
    if (divId =='4' ){ // auto start the countdown on Popup div 4
      startCountdown();
    }
  };

  const handleClose = () => {
    setactiveDiv(null);
  };

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  // Track hidden buttons
  const [hiddenButtons, setHiddenButtons] = useState([]);
  const handleHideButton = (targetId) => {
    setHiddenButtons(prev => (prev.includes(targetId) ? prev : [...prev, targetId]));
  };

  // Countdown
  const [seconds, setSeconds] = useState(null);
  const [message, setMessage] = useState('');
  const countdownRef = useRef(null);

  const startCountdown = () => {
    // Clear any existing timers
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
      countdownRef.current = null;
    }

    // Reset the state
    setMessage('');
    setSeconds(null);

    // Initial 1 second pause before countdown starts
    setTimeout(() => {
      let current = 10;
      setSeconds(current);
      setMessage(`${current} seconds remaining`);

      countdownRef.current = setInterval(() => {
        current -= 1;
        if (current > 0) {
          setSeconds(current);
          setMessage(`${current} seconds remaining`);
        } else {
          clearInterval(countdownRef.current);
          countdownRef.current = null;
          setMessage('0 seconds remaining');

          // Wait 1 second then update final message
          setTimeout(() => {
            setMessage('No luck... continue waiting?');
            setSeconds(null);
          }, 1000);
        }
      }, 1000);
    }, 1000);
  };


  // Timer adjust
  const { timeRemaining, formatTime, addPenalty, isRunning } = useTimer();
    
  const handleDecrease = () => {
    addPenalty();  // defaults to 1 minute or addPenalty(2) for a 2-minute penalty
  };

    const handleDecrease05 = () => {
    addPenalty(0.5);  // defaults to 1 minute or addPenalty(2) for a 2-minute penalty
  };


  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


    // Dynamically add CSS style classes to elements
    const [styledId, setStyledId] = useState(null);
  
    const handleStyleChange = (targetId) => {
      setStyledId(targetId);
    };


    // Go to next page
    const { goNext } = usePageControl();


  return (
    <div id="module-5" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <img src={ransomwareAlert} className={styledId === "bgrnd" ? "img-fluid-restrain hide" : "img-fluid-restrain"} alt="Alert message: Your files are encrypted!"/>

            <Popup
              className="popup-box-alert popup-box-no-footer"
              title="Your police files have been encrypted"
              isOpen={showPopup}
              onClose={() => setShowPopup(false)}
            >
              {activeDiv === null && (
                <div id="popup-content">
                  <div className="pop-up-image text-center">
                    <img src={popupImage} className="popup-image" alt="Image of a padlock"/>
                  </div>
                  <p>Will you:</p>
                  <button
                    id="button1"
                    onClick={() => { handleOpen(1); handleDecrease(); }}
                    className={`btn btn-white popup-option ${hiddenButtons.includes("button1") ? "hide" : ""}`}
                  >
                    Pay the ransom - £250,000
                  </button>
                  <button
                    id="button2"
                    onClick={() => { handleOpen(2); handleDecrease05(); }}
                    className={`btn btn-white popup-option ${hiddenButtons.includes("button2") ? "hide" : ""}`}
                  >
                    Try and break the 256-character password
                  </button>
                  <button
                    id="button3"
                    onClick={() => handleOpen(3)}
                    className={`btn btn-white popup-option ${hiddenButtons.includes("button3") ? "hide" : ""}`}
                  >
                    Restore from a secure backup
                  </button>
                  <button
                    id="button4"
                    onClick={() => handleOpen(4)}
                    className={`btn btn-white popup-option ${hiddenButtons.includes("button4") ? "hide" : ""}`}
                  >
                    Wait to see if a key is made available at nomoreransom.org
                  </button>
                </div>
              )}

              {activeDiv === 1 && (
                <div key={`1-${refreshKey}`} id="popup-alert-1" className="popup-alert">
                  <h3>Oh dear! No key!</h3>
                  <p>It appears the criminal hasn't provided you with the decryption key!</p>
                  <p>You have a 1 minute penalty.</p>
                  <button className="btn btn-white" onClick={() => { handleClose(); handleHideButton("button1"); }}>Close</button>
                </div>
              )}

              {activeDiv === 2 && (
                <div key={`2-${refreshKey}`} id="popup-alert-2" className="popup-alert">
                  <h3>Try and break the 256-character password</h3>
                  <p>A password this long is impossible to break.</p>
                  <p>You have a 30 second penalty.</p>
                  <button className="btn btn-white" onClick={() => { handleClose(); handleHideButton("button2"); }}>Close</button>
                </div>
              )}

              {activeDiv === 3 && (
                <div key={`3-${refreshKey}`} id="popup-alert-3" className="popup-alert">
                  <h3>Restore from a secure backup</h3>
                  <div id="loader"><div id="loader-bar" className="loader-bar-duration-5"></div></div>
                  <p className="opacity-show delay-6">Phew! Backup successful</p>
                  <p className="opacity-show delay-6">You've successfully restored your backup, well done!</p>
                  <p className="opacity-show delay-6">You can now continue.</p>
                  <button className="btn btn-white opacity-show delay-6" onClick={() => { goNext(); }}>Close</button>
                </div>
              )}  

              {activeDiv === 4 && (
                <div key={`4-${refreshKey}`} id="popup-alert-4" className="popup-alert">
                  <h3>Wait to see if a key is made available at nomoreransom.org</h3>
                  <p>Viewing nomoreransom.org...</p>
                  <img src={tumbleweed} className="img-fluid-restrain" alt="Tumbleweed rolling in the wind"/>
                  <p>{message}</p>
                  <button className="btn btn-white opacity-show delay-12" onClick={startCountdown}>Yes</button>
                  <button className="btn btn-white opacity-show delay-12" onClick={() => { handleClose(); handleHideButton("button4"); }}>No</button>
                </div>
              )}
            
              </Popup>

                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module5;
